@if (recorded(); as r) {
  <dl class="basis">
    <dt>Rule applied</dt>
    <dd>{{ r.basis.rule || 'No rule recorded' }}</dd>

    @if (r.inputs.length) {
      <dt>Inputs used</dt>
      <dd>
        <ul class="basis__inputs">
          @for (entry of r.inputs; track entry[0]) {
            <li>
              {{ words(entry[0]) }}:
              @if (isPlain(entry[1])) {
                {{ entry[1] }}
              } @else {
                <code class="basis__json">{{ entry[1] | json }}</code>
              }
            </li>
          }
        </ul>
      </dd>
    }

    <dt>The assessment's own ground</dt>
    <dd>
      @if (isQuoted(r.basis.ground)) {
        <q class="basis__ground">{{ r.basis.ground }}</q>
      } @else if (asEvidence(r.basis.ground).length) {
        <ul class="basis__inputs">
          @for (e of asEvidence(r.basis.ground); track $index) {
            <li>
              {{ words(e.factor_id) }}: <q class="basis__ground">{{ e.evidence }}</q>
            </li>
          }
        </ul>
      } @else {
        None recorded
      }
    </dd>

    @if (r.basis.outcome) {
      <dt>What came of it</dt>
      <dd>{{ words(r.basis.outcome) }}</dd>
    }

    @if (r.basis.reduction_log?.length) {
      <dt>Reduction log</dt>
      <dd>
        <table class="basis__log">
          <thead>
            <tr>
              <th scope="col">Factor</th>
              <th scope="col">Rate</th>
              <th scope="col">Value after</th>
            </tr>
          </thead>
          <tbody>
            @for (step of r.basis.reduction_log; track $index) {
              <tr>
                <td>{{ words(step.factor_id) }}</td>
                <td>{{ step.rate }}</td>
                <td>{{ step.value_after }}</td>
              </tr>
            }
          </tbody>
        </table>
      </dd>
    }

    @if (r.basis.binding_cap) {
      <dt>The cap that bound</dt>
      <dd>{{ words(r.basis.binding_cap) }}</dd>
    }

    @if (r.basis.bands) {
      @for (band of r.basis.bands | keyvalue; track band.key) {
        <dt>{{ words(band.key) }} band</dt>
        <dd>{{ band.value }}</dd>
      }
    }
  </dl>
} @else {
  <p class="basis__none" data-testid="no-basis">No basis recorded for this</p>
}
